import React from 'react'

// 日期输入：点整行（不只是右侧小图标）都弹出日历
export default function DateInput(props) {
  function open(e) {
    try { e.target.showPicker?.() } catch { /* showPicker 仅允许用户手势触发，失败忽略 */ }
  }
  return <input {...props} type="date" className={props.className || 'input'} onClick={open} onFocus={open} />
}
